import { useState } from 'react';

var useNullableState = function useNullableState() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return useState(initialValue);
};

export { useNullableState };
